<template>
    <div class="marginCon">
      <Card>
        <!-- 搜索 -->
        <div class="search-div">
            <!-- <Input class="input-div" placeholder="请输入名称搜索" clearable v-model="searchObj.name" ></Input>
            <Input class="input-div" placeholder="请输入上级名称搜索" clearable v-model="searchObj.top_name" ></Input>
            <Select placeholder="请选择状态搜索"  clearable class="input-div" v-model="searchObj.pay_status" >
                <Option v-for="(item, index) in searchObjArr.pay_status" :value="item.id" :key="index">{{item.val}}</Option>
            </Select>
            <Input class="input-div" placeholder="请输入合同编号搜索" clearable v-model="searchObj.contract_id" ></Input>
            <Select placeholder="请选择是否分账"  clearable class="input-div" v-model="searchObj.is_share" >
                <Option v-for="(item, index) in searchObjArr.is_share" :value="item.id" :key="index">{{item.val}}</Option>
            </Select>

            <Select placeholder="请选择收款类型"  clearable class="input-div" v-model="searchObj.type" >
                <Option value="1">抵押收费</Option>
                <Option value="2">解押收费</Option>
            </Select> -->

            <DatePicker class="input-div" type="datetimerange" @on-change='selectT'  format="yyyy-MM-dd HH:mm" :placeholder="$t('selectPlaceholder')" style="width: 300px"></DatePicker>

            <!-- <Input class="input-div" placeholder="请输入账号搜索" clearable v-model="searchObj.mobile" ></Input>
            <Input class="input-div" placeholder="请输入订单编号搜索" clearable v-model="searchObj.order_sn" ></Input> -->
             <Button type="info" @click="searchItem"  icon="ios-search" style="width:96px;border-radius: 6px;">{{$t('search')}}</Button>

            <!-- <Button type="primary" @click="searchItem">搜索</Button> -->
        </div>
        <div v-if="offModel">
            <Table style="width: 100%;margin-top: 30px;" :columns="titleName" :data="tableList.tableData"  ref="selection" @on-sort-change="sortCustom" :loading='loading'></Table>
            <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[10,15,20]" placement="top" class="pages"/>
        </div>
      </Card>
    </div>
</template>

<script>

import common from '@/common/common.js';
import moment from 'moment'
import { mapState } from 'vuex'

    export default {
        name: "firmwareVersion",
        components: {
        },
        data(){
            return{
                loading: true,
                offModel: true,
                page:{//分页排序
                    total:0,//总条数
                    pageSize:15,//每页条数
                    current:1,//当前页
                    key:'created_at',
                    order:'desc'
                },
                searchObj:{
                    startTime:'',
                    endTime:''
                },
                tableList:{
                    tableData:[]
                },
                
               
            }
        },
        computed:{
           ...mapState(['local','selectId']),
           titleName(){
               return [
                    {
                        title:this.$t('firmwareDownload.titleName.id'),
                        'title-en-US':'Firmware id',
                        key: 'id',
                        width: 120,
                        // sortable: true,
                        tree: true
                    },
                    {
                        title:this.$t('firmwareDownload.titleName.downloadTime'),
                        key: 'downloadTime',
                        width: 180,
                        render:(h, params)=>{
                            let stext = moment(params.row.downloadTime*1).format('YYYY-MM-DD HH:mm:ss')
                            return h('div',stext || '')
                        }
                    },
                    {
                        title:this.$t('firmwareDownload.titleName.userAccount'),
                        key: 'userAccount',
                        width: 130
                    },
                    {
                        title:this.$t('firmwareDownload.titleName.serialNumber'),
                        key: 'serialNumber',
                        width: 180
                    },
                    
                    {
                        title:this.$t('firmwareDownload.titleName.deviceType'),
                        key: 'deviceType',
                        minWidth: 150
                    },
                    {
                        title:this.$t('firmwareDownload.titleName.beforeDownVersion'),
                        key: 'beforeDownVersion',
                        minWidth: 240
                    },
                   
                    {
                        title:this.$t('firmwareDownload.titleName.afterDownVersion'),
                        'title-zh-CN':'现在版本',
                        'title-en-US':'Now version',
                        key: 'afterDownVersion',
                        minWidth: 240
                    }
                ]
           } 
        },
        created (){
          
            this.getData()
        },
        methods: {
            selectT(val){
               this.searchObj.startTime = val[0]?new Date(val[0]).getTime():""
               this.searchObj.endTime = val[1]?new Date(val[1]).getTime():""
            },
            searchItem(){
                this.loading = true
                this.getData()
            },
           
            getData(){ //获取数据
                let getData = {
                    params:{
                        page:this.page.current,
                        limit:this.page.pageSize,
                        sort:this.page.key,
                        asc:this.page.order,
                        dealerId:this.selectId,
                        ...this.searchObj
                    }
                }
                this.axios.post(this.config.urlArray.fwareDownRecordsList,getData.params).then((result) => {
                    common.ajaxMsg(result.data,false,()=>{

                        let resData = result.data.data.downRecordList
                        //处理数组
                        if(resData){
                            this.tableList.tableData = resData  //渲染数据
                            this.page.total = result.data.data.meta.count
                            this.loading = false
                        }
                    });
                }).catch((err) => {
                    // common.msg('error',err,()=>{})
                });
            },
            sortCustom (data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                this.getData()
            },
            changePage (nowpage) {//切换分页
                this.page.current = nowpage
                this.getData()
            },
            changeSize (nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                this.getData()
            }
        }
    }
</script>



